import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const BagIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M10.49 4.33c0-.74.06-1.52-.38-2.15C9.67 1.45 8.84 1 7.99 1c-.85 0-1.68.46-2.12 1.18-.44.64-.38 1.41-.38 2.15H1V15h14V4.33h-4.51ZM6.73 2.71c.71-1.24 2.74-.71 2.76.71v.91H6.51c0-.53-.05-1.28.23-1.62h-.01ZM14 14H2V5.33h12V14Z" />
  </IconWrapper>
)

export default BagIconSmall
